import { render, staticRenderFns } from "./LessonWrapper.vue?vue&type=template&id=4843b10c"
import script from "./LessonWrapper.vue?vue&type=script&lang=js"
export * from "./LessonWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports